import React, { useEffect, useState } from "react";
import WebUtils from "../../../utils/WebUtils";
import { Input, Pagination, Skeleton } from "antd";
import HPPJobCard from "./HPPJobCard";
import Empty from "../../../assets/lotties/guidePageNoData.json";
import Lottie from "react-lottie";
import Icon from "../../../assets/Icon";

const loadingLottiFile = {
  loop: true,
  autoplay: true,
  animationData: Empty,
};

const baseUrl = WebUtils.getHireBaseUrl();
const pageSize = 5;

const HPPJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [totalJobs, setTotalJobs] = useState();
  const [jdState, setJdState] = useState("ACTIVE");
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [inputText, setInputText] = useState();

  const fetchJobsCount = async () => {
    let api = `${baseUrl}/aimatcher/api/v1/openpool/getOpenJobsCount?searchInput=${searchValue}&jdState=${jdState}`;
    try {
      const response = await fetch(api);
      const data = await response.json();
      if (data.resultStatusInfo.resultCode === "Success") {
        setTotalJobs(data.data);
      } else {
        console.error("Could not retrieve jobs");
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };
  useEffect(() => {
    fetchJobsCount();
  }, [searchValue]);

  useEffect(() => {
    fetchJobs();
  }, [currentPage, searchValue]);

  const fetchJobs = async () => {
    setLoading(true);
    let api = `${baseUrl}/aimatcher/api/v1/openpool/getOpenJobs?searchInput=${searchValue}&pageNumber=${
      currentPage - 1
    }&pageSize=${pageSize}&jdState=${jdState}`;
    try {
      const response = await fetch(api);
      const data = await response.json();
      if (data.resultStatusInfo.resultCode === "Success") {
        setJobs(data.data);
      } else if (data.resultStatusInfo.resultCode === "NotFound") {
        setJobs([]);
      } else {
        console.error("Could not retrieve jobs");
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching jobs:", error);
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearchJobs = () => {
    setSearchValue(inputText);
    setCurrentPage(1);
  };

  const handleClearSearch = () => {
    setInputText("");
    setSearchValue("");
    setCurrentPage(1);
  };
  return (
    <div className="w-full">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col md:flex-row items-center justify-start w-full gap-x-4 gap-y-0">
          <Input
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            className="basis-[50%] max-w-[400px] px-2 py-2 border border-[#D0D5DD] shadow-sm"
            prefix={<Icon type="job-section-search" className="mr-2" />}
            placeholder={`Search jobs..`}
            onPressEnter={handleSearchJobs}
          />
          <div className="flex items-center gap-2 mt-4 md:mt-0">
            <button
              onClick={handleSearchJobs}
              className="btn-orange px-8 py-[7px] font-semibold text-[.9rem]"
            >
              Search
            </button>
            <button
              onClick={handleClearSearch}
              className="btn-white px-6 py-[7px] text-[.9rem]"
            >
              Clear
            </button>
          </div>
        </div>
        {loading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton.Button
              key={index}
              active
              block
              style={{ width: "100%", height: 140, borderRadius: "12px" }}
            />
          ))
        ) : jobs.length > 0 ? (
          jobs.map((job) => <HPPJobCard key={job.jdIdentifier} job={job} />)
        ) : (
          <div>
            <Lottie height={200} width={200} options={loadingLottiFile} />

            <p className="text-center text-base text-[#475467] mt-2 mb-8">
              No jobs available currently...
            </p>
          </div>
        )}
        {jobs.length > 0 && !loading ? (
          <Pagination
            current={currentPage}
            total={totalJobs}
            pageSize={pageSize}
            onChange={handlePageChange}
            showSizeChanger={false}
            className="mt-1 mx-auto"
          />
        ) : null}
      </div>
    </div>
  );
};

export default HPPJobs;
